import { Loader2, Trash } from 'lucide-react';
import { type ReactNode, useContext, useState } from 'react';
import { Button, type ButtonProps } from '@ui/button.tsx';
import { CartContext } from '@r/context/cart-context.ts';
import type { z } from 'zod';
import type { IStoreCartLineItemSchema } from '@r/types/zod-schemas.ts';

type DeleteButtonProps = {
  cartItem: z.infer<typeof IStoreCartLineItemSchema>;
  children?: ReactNode;
  className?: string;
  variant?: ButtonProps['variant'];
  size?: ButtonProps['size'];
  onDeleted?: () => void;
};

const DeleteButton = ({
  cartItem,
  children,
  className,
  variant = 'raw',
  size = 'icon',
  onDeleted
}: DeleteButtonProps) => {
  const { removeCartItem } = useContext(CartContext);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async (cartItem: z.infer<typeof IStoreCartLineItemSchema>) => {
    setIsDeleting(true);

    const result = await removeCartItem({ cartItem });
    setIsDeleting(false);

    if (result.success) {
      onDeleted?.();
    }
  };

  return (
    <Button
      className={className}
      variant={variant}
      size={size}
      onClick={() => handleDelete(cartItem)}
    >
      {isDeleting ? <Loader2 className="animate-spin" /> : <Trash />}
      <span>{children}</span>
    </Button>
  );
};

export { DeleteButton };
